import { useEffect,useState } from 'react'
import { getWallet,type Wallet as W } from './api'
import { mt } from '../lib/i18n'
import Icon from '../components/Icon'
import { playStoreOn } from './TokenStore'
import { TOKEN_VALUE } from '../../shared/market/model'

/** Play tokens, earned by three island creatures. Simulated: there is no money here. */
export default function Wallet(){
 const [w,setW]=useState<W|null>(null),[store,setStore]=useState(false)
 useEffect(()=>{void playStoreOn().then(setStore)},[])
 useEffect(()=>{let alive=true;getWallet().then(x=>{if(alive)setW(x)}).catch(()=>{/* optional */});return()=>{alive=false}},[])
 if(!w)return null
 const rows=[{k:'coqui',n:w.coqui,name:mt('walletCoqui'),why:mt('walletCoquiWhy')},{k:'parrot',n:w.parrot,name:mt('walletParrot'),why:mt('walletParrotWhy')},{k:'palm',n:w.palm,name:mt('walletPalm'),why:mt('walletPalmWhy')}] as const
 return <section className="wallet-card" aria-label={mt('walletTitle')}>
  <div className="wallet-head"><h2>{mt('walletTitle')}</h2><strong className="wallet-balance">{w.balance}</strong></div>
  <p className="wallet-note">{mt('earnWays')}</p>
  <ul className="wallet-list">{rows.map(r=><li key={r.k}><span className={`creature ${r.k}`} aria-hidden="true"><Icon name={r.k} size={26}/></span><div><strong>{r.name} <span className="wallet-x">× {r.n}</span></strong><small>{r.why} · +{TOKEN_VALUE[r.k]} {mt('walletEach')}</small></div></li>)}</ul>
  <p className="wallet-note">{mt('walletNote')}</p>{store&&<a className="market-button secondary wallet-get" href="#/tokens"><Icon name="star" size={16}/>{mt('tokGet')}</a>}
 </section>
}
